import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Camera, CheckCircle2, Stethoscope, Clock, DollarSign } from 'lucide-react';
export function ProviderSignUpScreen() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col min-h-screen bg-slate-50" data-id="element-1396">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10" data-id="element-1397">
        <div className="flex items-center gap-3 mb-4" data-id="element-1398">
          <button onClick={() => step > 1 ? setStep(step - 1) : navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-1399">
            <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-1400" />
          </button>
          <h1 className="text-xl font-bold text-slate-900" data-id="element-1401">Provider Sign Up</h1>
        </div>

        <div className="flex gap-2" data-id="element-1402">
          {[1, 2, 3, 4].map(i => <div key={i} className={`h-1.5 flex-1 rounded-full ${i <= step ? 'bg-blue-600' : 'bg-slate-200'}`} data-id="element-1403" />)}
        </div>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-1404">
        {step === 1 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="space-y-4" data-id="element-1405">
            <h2 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1406">
              Personal Information
            </h2>
            <div data-id="element-1407">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1408">
                Full Name (as on ID)
              </label>
              <input type="text" className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="Dr. Jane Doe" data-id="element-1409" />
            </div>
            <div data-id="element-1410">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1411">
                Phone Number
              </label>
              <input type="tel" className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="+234 XXX XXX XXXX" data-id="element-1412" />
            </div>
            <div data-id="element-1413">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1414">
                Email Address
              </label>
              <input type="email" className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="jane@example.com" data-id="element-1415" />
            </div>
          </motion.div>}

        {step === 2 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="space-y-6" data-id="element-1416">
            <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1417">
              Identity & Credentials
            </h2>

            <div data-id="element-1418">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1419">
                Medical License
              </label>
              <button className="w-full py-8 bg-white border-2 border-slate-200 border-dashed rounded-xl flex flex-col items-center gap-2 text-slate-500 hover:bg-slate-50 hover:border-blue-300 transition-colors" data-id="element-1420">
                <Camera className="w-8 h-8 text-slate-400" data-id="element-1421" />
                <span className="text-sm font-medium" data-id="element-1422">
                  Tap to upload license photo
                </span>
                <span className="text-xs text-slate-400" data-id="element-1423">
                  JPG, PNG or PDF (Max 5MB)
                </span>
              </button>
            </div>

            <div data-id="element-1424">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1425">
                Government ID
              </label>
              <button className="w-full py-8 bg-white border-2 border-slate-200 border-dashed rounded-xl flex flex-col items-center gap-2 text-slate-500 hover:bg-slate-50 hover:border-blue-300 transition-colors" data-id="element-1426">
                <Camera className="w-8 h-8 text-slate-400" data-id="element-1427" />
                <span className="text-sm font-medium" data-id="element-1428">
                  Tap to upload ID photo
                </span>
                <span className="text-xs text-slate-400" data-id="element-1429">
                  NIN, Passport, or Driver's License
                </span>
              </button>
            </div>
          </motion.div>}

        {step === 3 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="space-y-6" data-id="element-1430">
            <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1431">
              Professional Details
            </h2>

            <div data-id="element-1432">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1433">
                Primary Specialty
              </label>
              <select className="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" data-id="element-1434">
                <option data-id="element-1435">General Medicine</option>
                <option data-id="element-1436">Pediatrics</option>
                <option data-id="element-1437">Gynecology</option>
                <option data-id="element-1438">Nursing</option>
                <option data-id="element-1439">Caregiving</option>
              </select>
            </div>

            <div data-id="element-1440">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1441">
                Services Offered
              </label>
              <div className="space-y-2" data-id="element-1442">
                {['Clinic Visit', 'Home Visit', 'Video Consult', 'Chat Consult'].map(service => <label key={service} className="flex items-center gap-3 p-3 rounded-xl border border-slate-200 bg-white cursor-pointer" data-id="element-1443">
                    <input type="checkbox" className="w-5 h-5 rounded border-slate-300 text-blue-600 focus:ring-blue-600" defaultChecked data-id="element-1444" />
                    <span className="text-sm font-medium text-slate-700" data-id="element-1445">
                      {service}
                    </span>
                  </label>)}
              </div>
            </div>
          </motion.div>}

        {step === 4 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="space-y-6" data-id="element-1446">
            <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1447">
              Availability & Fees
            </h2>

            <div className="bg-blue-50 p-4 rounded-xl flex items-start gap-3 mb-4" data-id="element-1448">
              <Clock className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-1449" />
              <p className="text-sm text-blue-800" data-id="element-1450">
                You can adjust your schedule and fees anytime from your
                dashboard.
              </p>
            </div>

            <div data-id="element-1451">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1452">
                Base Consultation Fee (₦)
              </label>
              <div className="relative" data-id="element-1453">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1454">
                  <DollarSign className="w-5 h-5 text-slate-400" data-id="element-1455" />
                </div>
                <input type="number" className="w-full bg-white border border-slate-200 rounded-xl pl-10 pr-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="5000" defaultValue="5000" data-id="element-1456" />
              </div>
            </div>

            <div data-id="element-1457">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1458">
                Working Days
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-1459">
                {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, i) => <button key={day} className={`px-4 py-2 rounded-lg text-sm font-medium border ${i < 5 ? 'bg-blue-50 border-blue-200 text-blue-700' : 'bg-white border-slate-200 text-slate-600'}`} data-id="element-1460">
                      {day}
                    </button>)}
              </div>
            </div>
          </motion.div>}
      </div>

      <div className="p-6 bg-white border-t border-slate-100" data-id="element-1461">
        <button onClick={() => step < 4 ? setStep(step + 1) : navigate('/provider/verification')} className="w-full bg-blue-600 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm hover:bg-blue-700 transition-colors" data-id="element-1462">
          {step < 4 ? 'Continue' : 'Submit for Verification'}
        </button>
      </div>
    </motion.div>;
}